import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { isJobTrackEnable } from '/lib/helpers';
import Theme from '/imports/job-tracking/api/theme';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const Header = dynamic(() => import('/imports/dashboard/ui/components/Header'), { ssr: false });

const HeaderLayout = ({ requestLoad, children }) => {
  const {
    query: { jobtrack },
    asPath,
  } = useRouter();
  const isSearchV2 = asPath?.includes('/app/search-v2');

  const invertTheme = (theme) => {
    if (isJobTrackEnable() || jobtrack || isSearchV2) {
      return {
        ...theme,
        isJobTrack: true,
        jobTrack: Theme,
      };
    } else {
      return (theme) => theme;
    }
  };

  return (
    <ThemeProvider theme={invertTheme}>
      <StyleDdiv>
        <Header />
        {children}
      </StyleDdiv>
    </ThemeProvider>
  );
};

const StyleDdiv = styled.div`
  *:not(input, textarea) {
    user-select: text !important;
    -moz-user-select: text !important;
    -webkit-user-select: text !important;
  }
`;

export default HeaderLayout;
